import React, { Component, createRef } from 'react';
import ReactLoading from 'react-loading';
import SearchThinIcon from 'views/ui/icons/search-thin-icon';
import { brandNeutralColors } from 'ui_system/compass';

import './SearchFilter.scss';

class SearchFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: '',
    };
    this.searchInput = createRef();
  }

  applySearchFilter = () => {
    const { applyFilter } = this.props;
    const { searchTerm } = this.state;
    this.searchInput.blur();
    applyFilter('search', searchTerm);
  };

  clearSearchFilter = () => {
    const { applyFilter } = this.props;
    this.setState({ searchTerm: '' });
    applyFilter('search', '');
  };

  updateSearchTerm = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.applySearchFilter();
    }
  };

  renderSearchIcon = () => {
    return <SearchThinIcon className="search-icon" />;
  };

  renderClearLoading = () => {
    const { loading } = this.props;
    const { searchTerm } = this.state;
    if (loading) {
      return (
        <ReactLoading
          className="loading"
          type="spin"
          color={brandNeutralColors.text.icon}
          height="18px"
          width="18px"
          delay="0"
        />
      );
    }
    if (searchTerm.length > 0) {
      return <i onClick={this.clearSearchFilter} className="icon af-close" />;
    }
    return null;
  };

  render() {
    const { loading } = this.props;
    const { searchTerm } = this.state;
    return (
      <div className="search">
        {this.renderSearchIcon()}
        <input
          className="searchInput"
          placeholder="Search"
          ref={this.searchInput}
          value={searchTerm}
          onChange={this.updateSearchTerm}
          onKeyDown={this.handleKeyDown}
          disabled={loading}
        />
        {this.renderClearLoading()}
      </div>
    );
  }
}

export default SearchFilter;
